/** API istemcisi: mutlak URL yok, aynı origin (dev'de Vite proxy). Cookie oturumu, CORS yok. (erp deseni) */
export class ApiHata extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
  }
}

async function istek<T>(yol: string, init?: RequestInit): Promise<T> {
  const r = await fetch(`/api${yol}`, { ...init, headers: { "Content-Type": "application/json", ...(init?.headers ?? {}) }, credentials: "same-origin" });
  const govde = await r.json().catch(() => null);
  if (!r.ok) {
    // SUNUCU METNİ BURADA ÇEVRİLİR. `apps/api` tek dilli kalıyor (orada dizelerin bir bölümü
    // veri ve excel sözleşmesi, sunucuda çeviri onları bozma riski taşır). Sunucu İngilizce
    // döndürür, gösterim anında karşılığı aranır; sözlükte yoksa İngilizce görünür.
    // Ara değer taşıyan mesajlar (`Bilinmeyen tablo: X`) sabit anahtara uymaz, İngilizce kalır.
    const mesaj = (govde as { hata?: string; message?: string } | null)?.hata ?? (govde as { message?: string } | null)?.message ?? "An unexpected error occurred";
    throw new ApiHata(cevir(mesaj), r.status);
  }
  return govde as T;
}

/** Dosya indirme: hata gövdesi okunabilsin diye blob yolu; ad Content-Disposition'dan. */
async function indir(yol: string): Promise<void> {
  const r = await fetch(`/api${yol}`, { credentials: "same-origin" });
  if (!r.ok) {
    const g = (await r.json().catch(() => null)) as { hata?: string; message?: string } | null;
    throw new ApiHata(cevir(g?.hata ?? g?.message ?? "File could not be created"), r.status);
  }
  const ad = /filename="?([^"]+)"?/.exec(r.headers.get("Content-Disposition") ?? "")?.[1] ?? "oasis-disa-aktarim";
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement("a");
  a.href = url;
  a.download = ad;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

export const api = {
  get: <T>(yol: string) => istek<T>(yol),
  post: <T>(yol: string, govde?: unknown) => istek<T>(yol, { method: "POST", body: JSON.stringify(govde ?? {}) }),
  patch: <T>(yol: string, govde?: unknown) => istek<T>(yol, { method: "PATCH", body: JSON.stringify(govde ?? {}) }),
  put: <T>(yol: string, govde?: unknown) => istek<T>(yol, { method: "PUT", body: JSON.stringify(govde ?? {}) }),
  sil: <T>(yol: string) => istek<T>(yol, { method: "DELETE" }),
  indir,
};

import type { Rol } from "@oasis/domain";
import { cevir } from "@/lib/dil";
export interface Ben {
  id: string;
  ad: string;
  eposta: string;
  rol: Rol;
  rolEtiket: string;
  yonetici: boolean;
  /** Konsept (tasarım denemesi) sayfalarını görme izni; yalnız yapılandırılan hesapta true. */
  konsept?: boolean;
  /** Kimlik değiştirme açıksa asıl giren yönetici; yoksa null. */
  asil?: { id: string; ad: string; rol: Rol; rolEtiket: string } | null;
}
